export const DataDisplayVariant = {
  STYLE_A: 'styleA',
  STYLE_B: 'styleB',
  STYLE_C: 'styleC',
  STYLE_D: 'styleD',
  STYLE_E: 'styleE',
};

export const SkeletonValueSizeMap = {
  [DataDisplayVariant.STYLE_A]: '16px',
  [DataDisplayVariant.STYLE_B]: '20px',
  [DataDisplayVariant.STYLE_C]: '40px',
  [DataDisplayVariant.STYLE_D]: '20px',
  [DataDisplayVariant.STYLE_E]: '12px',
};

export const SkeletonTitleSizeMap = {
  [DataDisplayVariant.STYLE_A]: '14px',
  [DataDisplayVariant.STYLE_B]: '14px',
  [DataDisplayVariant.STYLE_C]: '16px',
  [DataDisplayVariant.STYLE_D]: '14px',
  [DataDisplayVariant.STYLE_E]: '10px',
};

export const VARIANTS_WITH_LARGE_ICON = [
  DataDisplayVariant.STYLE_B,
  DataDisplayVariant.STYLE_D,
  DataDisplayVariant.STYLE_E,
];
